export const UNCLUSTERED_COLOR = '#555';

const GOLDEN_ANGLE = 137.508;

export function clusterColor(index: number): string {
  const hue = (index * GOLDEN_ANGLE) % 360;
  return `hsl(${hue}, 65%, 60%)`;
}

export function buildClusterIndexMap(nodes: Array<{ project_id?: string | null }>): Map<string, number> {
  const map = new Map<string, number>();
  let idx = 0;
  for (const node of nodes) {
    if (node.project_id && !map.has(node.project_id)) {
      map.set(node.project_id, idx++);
    }
  }
  return map;
}
